export default __webpack_public_path__ + "images/T5.8720b93.png";